<template>
  <div v-if="loading" class="text-center">
      <b-row>
        <b-col md="6">
          <atom-spinner
            :animation-duration="1000"
            :size="60"
            color="#ff1d5e"
            class="float-right my-4"
          />
      </b-col>
    </b-row>
    </div>
  <div v-else class="animated fadeIn">
    <b-row>
      <b-col>
        <b-card
          header="Customer Report"
          border-variant="info"
          header-bg-variant="primary"
          header-text-variant="white"
        >
          <b-row>
            <b-col md="10"></b-col>
            <b-col md="2" class="my-1">
              <b-form-group label-cols-sm="3" class="mb-0">
                <b-input-group>
                  <b-input-group-append>
                    <download-excel
                      :fetch="downloadReportModal"
                      :fields="exportFields"
                      :type="'csv'"
                      :name="`CustomerReport_${Date.now()}.csv`"
                    >
                      <eb-button
                        classic="mr-1 btn-primary"
                        text="Download Report"
                        :disabled="false"
                      ></eb-button>
                    </download-excel>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <div class="mt-2">
            <b-table
              style="border-radius: 12px"
              :dark="dark"
              :hover="hover"
              :striped="striped"
              :bordered="bordered"
              :small="small"
              :fixed="fixed"
              responsive
              id="my-table"
              :current-page="currentPage"
              :per-page="perPage"
              :items="CustomerReportList"
              thead-class="header"
              :fields="Columns"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
            >
            </b-table>
          </div>
          <div style="float: right">
            <b-pagination
              v-model="currentPage"
              :per-page="perPage"
              :total-rows="CustomerReportList.length"
              aria-controls="my-table"
              prev-text="Prev"
              next-text="Next"
              hide-goto-end-buttons
            ></b-pagination>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import ebButton from "@/components/FormElements/Button";
import { exportFields } from "@/shared/constants/customer";
import { AtomSpinner } from "epic-spinners";
export default {
  name: "customer",
  components: {
    ebButton,
    AtomSpinner,
  },
  data: () => {
    return {
      customerData: [],
      exportFields: exportFields,
      loading: false,
      totalCount: 0,
      perPage: 10,
      sortBy: "createdAt",
      sortDesc: true,
      hover: true,
      striped: false,
      currentPage: 1,
      fixed: false,
      small: false,
      dark: false,
      bordered: true,
      reportCount: "",
      Columns: [
        {
          key: "customerNo",
        },
        {
          key: "fullName",
          label: "Name",
        },
        {
          key: "phone",
        },
        {
          key: "category",
        },
      ],
    };
  },
  computed: {
    CustomerReportList() {
      let data = this.$store.getters["customer/GetCustomerExportList"];
      let reportList = [];
      if (Array.isArray(data) && data.length > 0) {
        data.map((obj) => {
          let arrayObj = {
            customerNo: obj?.customerNo,
            fullName: `${obj?.name.first} ${obj?.name.last}`,
            phone: obj?.authentication?.phone,
            category: obj?.category,
            createdAt: obj?.createdAt,
            ...obj,
          };
          reportList.push(arrayObj);
        });
        return reportList;
      } else {
        this.loading = false;
        return [];
      }
    },
  },
  methods: {
    downloadReportModal() {
      this.$swal({
        title: 'Number of Reports',
        type: 'question',
        html: `
         <input id="swal-input" class="swal2-input" style="max-width: 20em" type="number" min="1" placeholder="Enter the number of reports">
        `,
        showCancelButton: true,
        confirmButtonText: 'Download',
        focusConfirm: false,
        cancelButtonText: 'Cancel',
        preConfirm: () => {
          const reportCount = this.$swal.getPopup().querySelector('#swal-input').value; 
          if (!reportCount || reportCount < 1) {
            this.$swal.showValidationMessage('Please enter a valid number of reports'); 
            return null;
          }
          return reportCount;
        }
      }).then(result => {
        if (result.value && result.value !== null) {
          const reportCount = result.value;
          this.downloadReport(reportCount);
        }
      });
    },
    async downloadReport(reportCount) {
      this.startDownload();
      let data = [];
      let loop = async page => {
       await this.$store
          .dispatch("customer/fetchCustomerExport", {
            page: 1,
            limit: reportCount,
          })
          .then(async res => {
            if (res.status === 1) {
              this.totalCount = res.meta.total;
              Array.prototype.push.apply(data,res.response);
                let array = this.getProcessedJson(data, exportFields);
                await this.exportAsCSV(array,'customers');
                this.finishDownload();
            }
          });
      };
      loop(1);
      if(data.length !== 0){
        return data;
      }
    },
    getProcessedJson(data, header) {
      let keys = this.getKeys(data, header);
      let newData = [];
      let _self = this;
      data.map(function(item, index) {
        let newItem = {};
        for (let label in keys) {
          let property = keys[label];
          newItem[label] = _self.getValue(property, item);
        }
        newData.push(newItem);
      });
      return newData;
    },
    getValue(key, item) {
      const field = typeof key !== "object" ? key : key.field;
      let indexes = typeof field !== "string" ? [] : field.split(".");
      let value = this.defaultValue;
      if (!field) value = item;
      else if (indexes.length > 1)
        value = this.getValueFromNestedItem(item, indexes);
      else value = this.parseValue(item[field]);
      if (key.hasOwnProperty("callback"))
        value = this.getValueFromCallback(value, key.callback);
      return value;
    },
    getKeys(data, header) {
      if (header) {
        return header;
      }
      let keys = {};
      for (let key in data[0]) {
        keys[key] = key;
      }
      return keys;
    },
    getValueFromCallback(item, callback) {
      if (typeof callback !== "function") return this.defaultValue;
      const value = callback(item);
      return this.parseValue(value);
    },
    getValueFromNestedItem(item, indexes) {
      let nestedItem = item;
      for (let index of indexes) {
        if (nestedItem) nestedItem = nestedItem[index];
      }
      return this.parseValue(nestedItem);
    },
    parseValue(value) {
      return value || value === 0 || typeof value === "boolean" ? value : "";
    },
    startDownload() {
      this.$toasted.info("Downloading..");
    },
    finishDownload() {
      this.$toasted.clear();
      this.$toasted.success("Report downloaded");
    }
  },
  async mounted() {
    this.loading = true;
      let loop = async page => {
       await this.$store
          .dispatch("customer/fetchCustomerExport", {
            page: page,
            limit: 500
          }) 
          this.loading = false;
      };
      loop(1);    
  },
};
</script>
<style scoped>
.edit {
  color: #ffffff !important;
}
.bin {
  color: white !important;
}
</style>
